export default {
  alternativeController: {
    id: 'product_jp_carousel_alternative_controller',
    defaultMessage: 'Controller',
  },
  alternativeNext: {
    id: 'product_jp_carousel_alternative_next',
    defaultMessage: 'Next',
  },
  alternativePrevious: {
    id: 'product_jp_carousel_alternative_previous',
    defaultMessage: 'Previous',
  },
  alternativeClose: {
    id: 'product_jp_carousel_alternative_close',
    defaultMessage: 'Close',
  },
  warrantyJPDescription: {
    id: 'product_jp_carousel_warranty_description',
    defaultMessage: 'Warranty description',
  },
  batteryJPDescription: {
    id: 'product_jp_carousel_battery_description',
    defaultMessage: 'Battery description',
  },
  insuranceJPDescription: {
    id: 'product_jp_carousel_insurance_description',
    defaultMessage: 'Insurance description',
  },
}
